import { supabase } from './client';

export const getMaintenanceStatus = async () => {
    try {
        const { data, error } = await supabase
            .from('AppConfig')
            .select('value')
            .eq('key', 'maintenance_mode')
            .maybeSingle();

        if (error) {
            console.warn('Failed to fetch maintenance status:', error);
            return { isActive: false, message: '' };
        }

        const config = data?.value || { isActive: false, message: '' };

        return {
            isActive: config.isActive === true,
            message: config.message || 'We are currently performing scheduled maintenance. Please check back soon.',
        };
    } catch (e) {
        console.warn('Failed to fetch maintenance status:', e);
        return { isActive: false, message: '' };
    }
};

export const getMinimumAppVersion = async () => {
    try {
        const { data, error } = await supabase
            .from('AppConfig')
            .select('value')
            .eq('key', 'minimum_app_version')
            .maybeSingle();

        if (error) {
            console.warn('Failed to fetch minimum app version:', error);
            return null;
        }

        return data?.value || null;
    } catch (e) {
        console.warn('Failed to fetch minimum app version:', e);
        return null;
    }
};
